// TeamPageSkeleton.jsx
import React from "react";
import "./teamPageSkeleton.css";

const TeamPageSkeleton = () => {
	return (
		<div className="sf-team-skel">

			{/* Header */}
			<div className="sf-skel-row between">
				<div className="sf-skel-line w-40 shimmer"></div>
				<div className="sf-skel-btn shimmer"></div>
			</div>

			{/* Staff card horizontal list */}
			<div className="sf-skel-staff-scroll">
				{Array.from({ length: 4 }).map((_, i) => (
					<div key={i} className="sf-skel-staff-card shimmer">
						<div className="sf-skel-avatar shimmer"></div>
						<div className="sf-skel-line w-70 shimmer"></div>
						<div className="sf-skel-line w-50 shimmer"></div>
						<div className="sf-skel-chip shimmer"></div>
					</div>
				))}
			</div>

			{/* Expanded profile view */}
			<div className="sf-skel-profile shimmer">
				<div className="sf-skel-profile-header">
					<div className="sf-skel-avatar-large shimmer"></div>

					<div className="sf-skel-profile-info">
						<div className="sf-skel-line w-60 shimmer"></div>
						<div className="sf-skel-line w-40 shimmer"></div>
						<div className="sf-skel-line w-30 shimmer"></div>
					</div>
				</div>

				{/* Section Title */}
				<div className="sf-skel-line w-40 shimmer" style={{ marginTop: "26px" }}></div>

				{/* Services List */}
				<div className="sf-skel-service-list">
					{Array.from({ length: 3 }).map((_, i) => (
						<div key={i} className="sf-skel-service-row shimmer"></div>
					))}
				</div>
			</div>
		</div>
	);
};

export default TeamPageSkeleton;
